export const ErrorMessageContents = {
    DpcNprAccountDenied:
        "This plan includes disqualifying pension credit. Unfortunately, instructions cannot be completed online. Please contact us on 0345 279 1001.",
    SubAccountWizardLinkRestricted:
        "You cannot process this action until pension event is authorised",
    InActiveAccountRestriction: "You cannot process this action until the account is active",
    FCAPermissionDenied : "FCA Permissions prevents the following action.",
    TrustRestriction : "This journey is not available for this type of Trust.",
    PensionAuthoriseRestriction : "You cannot process this action until pension event is authorised.",
    PensionActivitiesSuspended: "An account with suspended or restricted activities cannot start this journey."
};